<template>
  <div class="mt-8">
    <h3 class="text-center text-sm text-gray-500 mb-3 font-mono">
      Top Polymarket events by volume:
    </h3>
    <div class="flex flex-wrap gap-2 justify-center px-4 max-w-3xl mx-auto">
      <button
        v-for="slug in topSlugs"
        :key="slug.slug"
        @click="navigateToMarket(slug)"
        class="px-3 py-1 text-sm bg-gray-50 text-gray-600 rounded-full border border-gray-200 hover:bg-gray-100 transition-colors duration-200 font-mono whitespace-nowrap"
      >
        {{ slug.label }}
      </button>
    </div>
  </div>
</template>

<script>
import ms from 'ms'

export default {
  name: 'TopSlugs',
  data() {
    return {
      topSlugs: []
    }
  },
  async created() {
    try {
      const cachedData = localStorage.getItem('topSlugsCache')
      const cachedTimestamp = localStorage.getItem('topSlugsCacheTimestamp')
      const CACHE_DURATION = ms('30m') // Using ms library for duration

      if (cachedData && cachedTimestamp && Date.now() - parseInt(cachedTimestamp) < CACHE_DURATION) {
        this.topSlugs = JSON.parse(cachedData)
      } else {
        const response = await fetch('https://api.nevua.markets/markets/top-slugs/polymarket')
        this.topSlugs = await response.json()
        localStorage.setItem('topSlugsCache', JSON.stringify(this.topSlugs))
        localStorage.setItem('topSlugsCacheTimestamp', Date.now().toString())
      }
    } catch (error) {
      console.error('Error fetching top slugs:', error)
    }
  },
  methods: {
    navigateToMarket(slug) {
      this.$router.push(`/polymarket/${slug.slug}`)
    }
  }
}
</script>
